import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import axiosJWT from './JwtToken'
import socket from './chat/SocketConfig'
import { useAuth } from './AuthContext'

const Sidebar = ({ open, setOpen }) => {

    const { isLoggedIn, logout } = useAuth()
    const [profil, setProfil] = useState([])
    const [keyword, setKeyword] = useState("")
    const [optLaporan, setOptLaporan] = useState([])
    const [unreadCount, setUnreadCount] = useState(0)

    const closeSidebar = () => setOpen(false)

    useEffect(() => {
        getProfil()
        getLaporan()
    }, [])

    // Ambil profil sosmed DPMPTSP
    const getProfil = async () => {
        try {
            const response = await axios.get('/api/profil/publish')
            setProfil(response.data || [])
        } catch (err) {
            console.error("Gagal load profil:", err)
        }
    }

    // Ambil list dinamis kategori laporan
    const getLaporan = async (filter) => {
        try {
            const response = await axios.post("/api/laporan/kategori/load", {
                key: filter,
                jml: 1000
            })
            setOptLaporan(response.data || [])
        } catch (err) {
            setOptLaporan([])
        }
    }

    useEffect(() => {
        // A. AMBIL DATA AWAL (Saat page di-refresh, angka gak bakal 0 lagi)
        const fetchUnreadCount = async () => {
            try {
                // Lu perlu bikin endpoint GET /api/notifications/count-unread di backend
                const res = await axiosJWT.get('/api/notifications/count-unread')
                setUnreadCount(res.data.count)
            } catch (err) {
                console.error("Gagal ambil jumlah notif:", err)
            }
        }
        fetchUnreadCount()

        // B. LISTENER REAL-TIME (Angka update otomatis pas ada chat masuk)
        socket.on('update_unread_count', (newCount) => {
            setUnreadCount(newCount)
        })

        // Cleanup
        return () => socket.off('update_unread_count')
    }, [])

    const handleLogout = async () => {
        try {
            await axios.delete('/api/pelaku-usaha/logout')
        } catch (err) {
            console.error("Logout error:", err)
            // Tetap lanjut logout secara lokal meski API error agar user tidak "nyangkut"
        } finally {
            // Panggil fungsi logout dari Context
            logout()
        }
    }

    const search = (e) => {
        e.preventDefault()
        const key = encodeURIComponent(keyword)
        closeSidebar()
        window.location.replace(`/pencarian/${key}`)
    }

    const logoStyle = {
        height: "30px"
    }

    return (
        <>
            <div className={`ms-slidebar sb-slidebar sb-left sb-style-overlay ${open ? 'open' : ''}`} id="ms-slidebar">
                <div className="sb-slidebar-container">
                    <header className="ms-slidebar-header">
                        <div className="ms-slidebar-title">
                            <form className="search-form" onSubmit={search}>
                                <input id="search-box-slidebar" type="text" className="search-input" placeholder="Search..." value={keyword} onChange={(e) => setKeyword(e.target.value)} />
                                <label htmlFor="search-box-slidebar"><i className="zmdi zmdi-search"></i></label>
                            </form>
                            <div className="ms-slidebar-t">
                                <img style={logoStyle} src="/assets/img/logo-header.png" alt='Logo' />
                            </div>
                        </div>
                    </header>

                    <ul className="ms-slidebar-menu" id="slidebar-menu" role="tablist" aria-multiselectable="true">
                        <li>
                            <Link className="link" to={"/"} onClick={closeSidebar}><i className="zmdi zmdi-home"></i> Beranda</Link>
                        </li>

                        {/* 1. MENGAPA KOTA BEKASI? */}
                        <li className="card" role="tab" id="sch-mengapa">
                            <a className="collapsed" role="button" data-toggle="collapse" href="#sc-mengapa" aria-expanded="false" aria-controls="sc-mengapa">
                                <i className="zmdi zmdi-city-alt"></i> Mengapa Kota Bekasi?
                            </a>
                            <ul id="sc-mengapa" className="card-collapse collapse" role="tabpanel" aria-labelledby="sch-mengapa" data-parent="#slidebar-menu">
                                <li><Link to={"/mengapa-kota-bekasi/demografi"} onClick={closeSidebar}>Demografi</Link></li>
                                <li><Link to={"/mengapa-kota-bekasi/geografis"} onClick={closeSidebar}>Geografis</Link></li>
                                <li><a href="https://oss.go.id" target="_blank" rel="noopener noreferrer" onClick={closeSidebar}>OSS</a></li>
                                <li><a href="https://silat.bekasikota.go.id" target="_blank" rel="noopener noreferrer" onClick={closeSidebar}>Silat V2</a></li>
                                <li><Link to={"/survey-kepuasan-masyarakat/testimoni"} onClick={closeSidebar}>Testimoni Investor</Link></li>
                            </ul>
                        </li>

                        {/* 2. LAYANAN DAN PENGADUAN */}
                        <li className="card" role="tab" id="sch-layanan">
                            <a className="collapsed" role="button" data-toggle="collapse" href="#sc-layanan" aria-expanded="false" aria-controls="sc-layanan">
                                <i className="zmdi zmdi-assignment-account"></i> Layanan & Pengaduan
                            </a>
                            <ul id="sc-layanan" className="card-collapse collapse" role="tabpanel" aria-labelledby="sch-layanan" data-parent="#slidebar-menu">
                                <li><Link to={"/layanan-dan-pengaduan/prosedur/memulai-bisnis"} onClick={closeSidebar}>Memulai Bisnis</Link></li>
                                <li><Link to={"/layanan-dan-pengaduan/prosedur/peraturan"} onClick={closeSidebar}>Peraturan Perundang Undangan</Link></li>
                                <li><Link to={"/layanan-dan-pengaduan/prosedur/pelayanan"} onClick={closeSidebar}>Pelayanan</Link></li>
                                <li><Link to={"/layanan-dan-pengaduan/prosedur/pengaduan"} onClick={closeSidebar}>Pengaduan</Link></li>
                                <li><Link to={"/layanan-dan-pengaduan/prosedur/panduan-aplikasi"} onClick={closeSidebar}>Panduan Aplikasi</Link></li>
                                <li><Link to={'/layanan-dan-pengaduan/open-data/layanan-terbuka'} onClick={closeSidebar}>Open Data</Link></li>
                                <li><Link to={"/layanan-dan-pengaduan/hubungi-kami/kontak"} onClick={closeSidebar}>Kontak & Lokasi</Link></li>
                                <li><a href="https://mpp.bekasikota.go.id" target="_blank" rel="noopener noreferrer" onClick={closeSidebar}>Simple Antri</a></li>
                            </ul>
                        </li>

                        {/* 3. INFO PUBLIK */}
                        <li className="card" role="tab" id="sch-info">
                            <a className="collapsed" role="button" data-toggle="collapse" href="#sc-info" aria-expanded="false" aria-controls="sc-info">
                                <i className="zmdi zmdi-info-outline"></i> Info Publik
                            </a>
                            <ul id="sc-info" className="card-collapse collapse" role="tabpanel" aria-labelledby="sch-info" data-parent="#slidebar-menu">
                                <li><Link to={"/info/siaran-pers"} onClick={closeSidebar}><i className='fa fa-bullhorn'></i> Siaran Pers</Link></li>
                                <li><Link to={"/info/galeri"} onClick={closeSidebar}><i className='fa fa-picture-o'></i> Galeri</Link></li>
                                <li><Link to={"/info/artikel-publikasi"} onClick={closeSidebar}><i className='fa fa-newspaper-o'></i> Artikel & Publikasi</Link></li>
                                <li><Link to={"/info/agenda-kegiatan"} onClick={closeSidebar}><i className='fa fa-calendar-check-o'></i> Agenda Kegiatan</Link></li>
                                <li><Link to={"/info/pengumuman"} onClick={closeSidebar}><i className='fa fa-info'></i> Pengumuman</Link></li>
                            </ul>
                        </li>

                        {/* 4. LAPORAN */}
                        <li className="card" role="tab" id="sch-laporan">
                            <a className="collapsed" role="button" data-toggle="collapse" href="#sc-laporan" aria-expanded="false" aria-controls="sc-laporan">
                                <i className="zmdi zmdi-collection-pdf"></i> Laporan
                            </a>
                            <ul id="sc-laporan" className="card-collapse collapse" role="tabpanel" aria-labelledby="sch-laporan" data-parent="#slidebar-menu">
                                {/* <li><Link to={`/laporan/realisasi-tjsl`} onClick={closeSidebar}>Realisasi TJSL/CSR</Link></li> */}
                                {optLaporan.map((val, i) => (
                                    <li key={i}>
                                        <Link to={`/laporan/${val.namaKategori.replaceAll(' ', '-')}`} onClick={closeSidebar}>
                                            {val.namaKategori.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </li>

                        {/* 5. PROFIL DPMPTSP */}
                        <li className="card" role="tab" id="sch-profil">
                            <a className="collapsed" role="button" data-toggle="collapse" href="#sc-profil" aria-expanded="false" aria-controls="sc-profil">
                                <i className="zmdi zmdi-balance"></i> Profil DPMPTSP
                            </a>
                            <ul id="sc-profil" className="card-collapse collapse" role="tabpanel" aria-labelledby="sch-profil" data-parent="#slidebar-menu">
                                <li><Link to={"/tentang-dpmptsp/profil"} onClick={closeSidebar}><i className='fa fa-building-o'></i> Profil</Link></li>
                                <li><Link to={"/tentang-dpmptsp/struktur-organisasi"} onClick={closeSidebar}><i className='fa fa-sitemap'></i> Struktur Organisasi</Link></li>
                                <li><Link to={"/tentang-dpmptsp/profil-pejabat"} onClick={closeSidebar}><i className='fa fa-users'></i> Profil Pejabat</Link></li>
                                <li><Link to={"/tentang-dpmptsp/struktur-ppid"} onClick={closeSidebar}><i className='fa fa-sitemap'></i> Struktur PPID</Link></li>
                                <li><Link to={"/tentang-dpmptsp/janji-layanan"} onClick={closeSidebar}><i className='fa fa-handshake-o'></i> Janji Layanan</Link></li>
                                <li><Link to={"/tentang-dpmptsp/maklumat-dpmptsp"} onClick={closeSidebar}><i className='fa fa-hand-peace-o'></i> Maklumat DPMPTSP</Link></li>
                                <li><Link to={"/tentang-dpmptsp/visi-misi-kota-bekasi"} onClick={closeSidebar}><i className='fa fa-hand-rock-o'></i> Visi dan Misi DPMPTSP</Link></li>
                            </ul>
                        </li>

                        {/* LOGIC RE-POSITION MENU AKUN */}
                        {isLoggedIn ? (
                            <li className="card" role="tab" id="sch-akun-user">
                                <a className="collapsed" role="button" data-toggle="collapse" href="#sc-akun-user" aria-expanded="false" aria-controls="sc-akun-user">
                                    <i className="zmdi zmdi-account-circle"></i> Akun Saya
                                    {unreadCount > 0 && (
                                        <span className="badge-pill badge-pill-pink">{unreadCount > 9 ? '9+' : unreadCount}</span>
                                    )}
                                </a>
                                <ul id="sc-akun-user" className="card-collapse collapse" role="tabpanel" aria-labelledby="sch-akun-user" data-parent="#slidebar-menu">
                                    <li><Link to={"/akun/manajemen"} onClick={closeSidebar}><i className='fa fa-user'></i> Akun</Link></li>
                                    <li><Link to={"/akun/profil-usaha"} onClick={closeSidebar}><i className='fa fa-building'></i> Profil Usaha</Link></li>
                                    <li><Link to={"/akun/kegiatan-usaha"} onClick={closeSidebar}><i className='fa fa-briefcase'></i> Kegiatan Usaha</Link></li>
                                    <li><Link to={"/akun/promosi"} onClick={closeSidebar}><i className='fa fa-gift'></i> Promosi</Link></li>
                                    <li><Link to={"/akun/kebutuhan-pengadaan"} onClick={closeSidebar}><i className='fa fa-cubes'></i> Kebutuhan Pengadaan</Link></li>
                                    <li><Link to={"/akun/pencatatan-kemitraan-mandiri"} onClick={closeSidebar}><i className='fa fa-file-pdf-o'></i> Pencatatan Kemitraan Mandiri</Link></li>
                                    <li><Link to={"/akun/monitoring-pengadaan"} onClick={closeSidebar}><i className='fa fa-cart-plus'></i> Monitoring Pengadaan</Link></li>
                                    <li><Link to={"/akun/penawaran-masuk"} onClick={closeSidebar}><i className='fa fa-handshake-o'></i> Penawaran Masuk</Link></li>
                                    <li><Link to={"/akun/janjian"} onClick={closeSidebar}><i className='fa fa-calendar'></i> Janjian</Link></li>
                                    <li><Link to={"/akun/kemitraan-tjsl"} onClick={closeSidebar}><i className='fa fa-users'></i> Kemitraan TJSL/CSR</Link></li>
                                    <li style={{ borderTop: '1px dashed #ddd' }}>
                                        <button
                                            onClick={handleLogout}
                                            style={{
                                                background: 'transparent',
                                                border: 'none',
                                                color: '#f44336',
                                                width: '100%',
                                                textAlign: 'left',
                                                padding: '12px 15px 12px 25px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            <i className="fa fa-sign-out"></i> Keluar (Logout)
                                        </button>
                                    </li>
                                </ul>
                            </li>
                        ) : (
                            <li>
                                <Link className="link" to={"/login"} onClick={closeSidebar}><i className="zmdi zmdi-account"></i> Login</Link>
                            </li>
                        )}
                    </ul>

                    {/* Social Links */}
                    <div className="ms-slidebar-social ms-slidebar-block">
                        <h4 className="ms-slidebar-block-title">Social Links</h4>
                        <div className="ms-slidebar-social">
                            <a target="_blank" rel="noopener noreferrer" href={profil.youtube || '#'} className="btn-circle btn-circle-raised btn-google"><i className="zmdi zmdi-youtube-play"></i></a>
                            <a target="_blank" rel="noopener noreferrer" href={profil.facebook || '#'} className="btn-circle btn-circle-raised btn-facebook"><i className="zmdi zmdi-facebook"></i></a>
                            <a target="_blank" rel="noopener noreferrer" href={profil.instagram || '#'} className="btn-circle btn-circle-raised btn-instagram"><i className="zmdi zmdi-instagram"></i></a>
                            <a target="_blank" rel="noopener noreferrer" href={profil.twitter || '#'} className="btn-circle btn-circle-raised btn-twitter"><i className="zmdi zmdi-twitter"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sidebar